(function() {
    'use strict';
    angular.module('app', [
        'app.common',
        'app.widgets',
        'app.filters',
        /* custom mdoules */
        'app.modules'
    ]);
})();

